export default "__VITE_ASSET__Cmdgs0OU__"